const state = {
  isLoading: false,
  isUpdating: false,
  isDeleting: false
};

const getters = {
  isLoading(state) {
    return state.isLoading;
  },

  isUpdating(state) {
    return state.isUpdating;
  },

  isDeleting(state) {
    return state.isDeleting;
  }
};

const mutations = {
  setLoading(state, value) {
    state.isLoading = value;
  },

  setUpdating(state, value) {
    state.isUpdating = value;
  },

  setDeleting(state, value) {
    state.isDeleting = value;
  }
};

const actions = {
  reset({ commit }) {
    commit('setLoading', false);
    commit('setUpdating', false);
    commit('setDeleting', false);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
